import React from "react";
import styles from "./StatCards.module.css";
import {
  FaCheckCircle,
  FaHandshake,
  FaUsers,
  FaCalendarAlt,
} from "react-icons/fa";

const StatsCards = () => {
  const cards = [
    {
      id: 1,
      icon: <FaCheckCircle />,
      title: "Profile Status",
      value: "Complete",
    },
    { id: 2, icon: <FaHandshake />, title: "Active MoUs", value: "3" },
    { id: 3, icon: <FaUsers />, title: "Linked Members", value: "150+" },
    {
      id: 4,
      icon: <FaCalendarAlt />,
      title: "Membership Valid Till",
      value: "Dec 2026",
    },
  ];

  return (
    <div className={styles.cardsRow}>
      {cards.map((c) => (
        <div key={c.id} className={styles.card}>
          <div className={styles.icon}>{c.icon}</div>
          <div>
            <h4 className={styles.cardTitle}>{c.title}</h4>
            <p className={styles.cardValue}>{c.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
